
import { DialogManager } from '@tencent/wphk-components-dialog-manager';
import { difference, isEmpty } from 'lodash-es';
import { reactive, ref, nextTick } from 'vue';
import { dialogManager, getDialogList } from '../business/dialog-manager';
import { InitEmitMessage } from '../store/module-manager';

const globalDialogManager: Pick<DialogManager, 'readyDialog' | 'showDialogList' | 'readyAndShow' | 'hideDialog'> = reactive(dialogManager);

export const useDialogManager = () => {
  // 有弹窗的模块：
  const modulesWithDialog = getDialogList().map(item => item.moduleName);

  const isDialogManagerReady = ref(false);
  const handleDialogManager = (initedModule: InitEmitMessage[]) => {
    if (isDialogManagerReady.value) {
      return;
    }
    const initedModuleNames = initedModule.map(item => item.moduleName);
    // 有弹窗、但还未初始化的模块
    const notInitedModuleWithDialog = difference(modulesWithDialog, initedModuleNames);
    if (isEmpty(notInitedModuleWithDialog)) {
      // 如果所有有弹窗的模块都已经初始化好了
      console.log('====dialog isDialogManagerReady');
      isDialogManagerReady.value = true;
      nextTick(() => {
        globalDialogManager.showDialogList();
      });
    }
  };

  const showWithDialogManager = (dialogName: string, func: Function) => (...args) => {
    if (!globalDialogManager) throw new Error('未在类成员上发现dialog manager');
    globalDialogManager.readyDialog({
      name: dialogName,
      showHandler: () => func.apply(globalDialogManager, args),
    });
  };

  const hideWithDialogManager = (dialogName: string, func: Function) => (...args) => {
    if (!globalDialogManager) throw new Error('未在类成员上发现dialog manager');
    globalDialogManager.hideDialog(dialogName);
    return func.apply(globalDialogManager, args);
  };

  return {
    globalDialogManager,
    handleDialogManager,
    showWithDialogManager,
    hideWithDialogManager,
  };
};
